export enum FileTypeEnum {
    UserImage = 'user-image',
    StoreImage = 'store-image',
    ProductImage = 'product-image',
    BrandImage = 'brand-image',
    SellerBrandProof = 'seller-brand-proof',
    StoreLegalDocument = 'store-legal-document',
    Icon = 'icon',
    BulkUploadCSVResponse = 'bulk-upload-c-s-v-response',
  }
  